export default class Payment {
    constructor() {
        this.input = document.querySelector("#payment_voucher")
        this.preview = document.querySelector("#voucher-preview")
        this.previewLink = document.querySelector("#voucher-preview-link")
        if (this.input) this.events()
    }

    events() {
        this.input.addEventListener("change", (e) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.preview.src = e.target.result;
                    this.previewLink.href = e.target.result;
                }
                reader.readAsDataURL(file);
            }
        })
    }
}